import {
  Box,
  Button,
  Dialog,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState
} from "react";
import { useIntl } from "react-intl";

const useStyle = makeStyles(
  () => ({
    dialog: {
      width: "448px",
      // height: "464px",
      padding: "32px 24px 32px 24px",
      maxHeight: "calc(100vh - 64px)"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700
    },
    recordCount: {
      fontSize: "16px",
      padding: "24px 0px 24px 0px",
      "& span": {
        fontWeight: "bold"
      }
    },
    info: {
      fontSize: "14px",
      fontWeight: 700
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#FF2600",
      borderRadius: "4px",

      width: "178px",
      height: "48px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },
    table: {
      overflow: "scroll",
      maxWidth: "400px",
      marginTop: "8px",
      marginBottom: "32px",
      border: "1px solid #E0E0E0",
      borderRadius: "4px",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableRow-root": {
        "&:nth-child(even)": {
          background: "#EEEEEE",
          "&:hover": {
            backgroundColor: "#EEEEEE !important"
          }
        },
        "&:hover:not(.MuiTableRow-head):not(.MuiTableRow-footer)": {
          backgroundColor: "#white !important",
          position: "relative"
        },
        "&:before": {
          display: "none"
        }
      }
    }
  }),
  { name: "DialogErrorLine" }
);

export interface IRefDialog {
  onOpen: (errors: any) => void;
  visible: boolean;
  onClose: () => void;
}

export interface IError {
  field: string;
  message: string;
}

const DialogErrorLine: ForwardRefRenderFunction<IRefDialog> = (_props, ref) => {
  const classes = useStyle();
  const intl = useIntl();

  const [visible, setVisible] = useState<boolean>(false);
  const [errors, setErrors] = useState<null | IError[]>([]);

  const onClose = () => setVisible(false);

  const onOpen = (e: IError[]) => {
    setErrors(e);
    setVisible(true);
  };

  useImperativeHandle(ref, () => ({ onOpen, onClose, visible }));

  const StyledTableHead = withStyles(
    () => ({
      root: {
        "& .MuiTableCell-head": {
          backgroundColor: "#E0E0E0"
        }
      }
    }),
    { name: "StyledTableHead" }
  )(TableHead);

  const table = (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <StyledTableHead>
          <TableRow>
            <TableCell>
              <MyTypography variant="subtitle3">Line</MyTypography>
            </TableCell>
            <TableCell align="left">
              <MyTypography variant="subtitle3">Remark</MyTypography>{" "}
            </TableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {errors.length > 0 &&
            errors.map((row, index) => (
              <TableRow key={index}>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ fontWeight: "bold", color: "#222222" }}
                >
                  {row.field}
                </TableCell>
                <TableCell style={{ color: "#222222" }} align="left">
                  {row.message}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <Dialog
      open={visible}
      keepMounted
      onClose={onClose}
      style={{
        borderRadius: "16px",
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)"
      }}
    >
      <Box className={classes.dialog} display="flex" flexDirection={"column"}>
        <Typography className={classes.title}>
          {intl.formatMessage({
            defaultMessage: "การอัพโหลดไฟล์ไม่สำเร็จ",
            description: "error"
          })}
        </Typography>
        <Typography className={classes.recordCount}>
          {intl.formatMessage({
            defaultMessage: `ข้อมูลผิดพลาด `,
            description: "records"
          })}
          <span>{errors.length}</span> records
        </Typography>
        <Typography className={classes.info}>
          {intl.formatMessage({
            defaultMessage: "ข้อมูลเพิ่มเติม",
            description: "info"
          })}
        </Typography>

        {table}
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onClose}
        >
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage({
              defaultMessage: "ปิด",
              description: "close"
            })}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default forwardRef(DialogErrorLine);
